import { Component, OnInit } from '@angular/core';
import { NotificationModel } from '@models/notification.model';
import { NotificationService } from '@services/notifications.service';
import { Snackbar } from '@models/models';
import { TabModel, TabItemModel } from '@models/tab.model';
import { TranslateService } from '@ngx-translate/core';
import { SnackbarService } from '@services/snackbar.service';

@Component({
    selector: 'app-notifications',
    templateUrl: './notifications.component.html',
    styleUrls: ['./notifications.component.scss'],
})
export class NotificationsComponent implements OnInit {
    public show: boolean = false;
    public notifications: NotificationModel[][] = [[], []]; // unreaded ones 'received' | 'readed'
    public nextUrls: string[] = [null, null]; // [next_url_received, next_url_readed]
    public new: boolean = false; // true when has 'received' notifications
    public snackbar: Snackbar;
    public tabs: TabModel;

    constructor(
        private notificationService: NotificationService,
        private translate: TranslateService,
        private snackbarService: SnackbarService
    ) {}

    ngOnInit(): void {
        this.snackbar = this.snackbarService.snackbarItem;
        this.setTabs();
        this.loadFirstNotifications();
    }

    setTabs(): void {
        this.translate
            .get('NOTIFICATIONS.tabs.noReaded')
            .subscribe((translated: string) => {
                this.tabs = new TabModel([
                    new TabItemModel(0, translated, true),
                    new TabItemModel(
                        1,
                        this.translate.instant('NOTIFICATIONS.tabs.readed'),
                        false
                    ),
                ]);
            });
    }

    toggleNotifications(): void {
        this.show = !this.show;
        this.loadFirstNotifications();
    }

    loadFirstNotifications(): void {
        this.getNotifications('received');
        this.getNotifications('readed');
    }

    getIndexByStatus(status: string): number {
        return status === 'received' ? 0 : 1;
    }

    getNotifications(status: string): void {
        this.notificationService.getNotifications(status).subscribe(
            (response) => {
                const index = this.getIndexByStatus(status);
                this.nextUrls[index] = response['next'];
                this.notifications[index] = response['results']
                    ? response['results'].map((noti) => {
                          return new NotificationModel(
                              noti['id'],
                              noti['custom_content'],
                              noti['status'],
                              noti['created_at'],
                              noti['associated_id'],
                              noti['associated_type']
                          );
                      })
                    : [];
                this.areThereNews();
            },
            (error) => {
                console.log(error);
            }
        );
    }

    areThereNews(): void {
        this.new = this.notifications[0].length > 0 ? true : false;
    }

    toggleNotificationStatus(
        notification: NotificationModel,
        newStatus: string = null
    ): void {
        if (newStatus === null) {
            newStatus =
                notification.status === 'received' ? 'readed' : 'received';
        }
        notification.status = newStatus;
        this.notificationService
            .setNotificationStatus(notification.id, newStatus)
            .subscribe(
                (response) => {
                    this.areThereNews();
                },
                (error) => {
                    console.log(error);
                }
            );
    }

    /**
     * Mark all notifications for the current user as readed
     */
    markAllAsReaded(): void {
        this.notificationService.bulkNotifications('readed').subscribe(
            (response) => {
                this.setAllAsReaded();
                this.new = false;
            },
            (error) => {
                console.log(error);
                this.snackbar.text = error;
                this.snackbar.status_class = 'error';
                this.snackbar.activate();
            }
        );
    }

    setAllAsReaded(): void {
        this.notifications[0].map(
            (noti: NotificationModel) => (noti.status = 'readed')
        );
    }

    loadMoreNotifications(index: number): void {
        const url = this.nextUrls[index];
        if (url != null) {
            this.notificationService.loadMore(url).subscribe(
                (response) => {
                    this.nextUrls[index] = response['next'];
                    response['results'].map((noti) => {
                        this.notifications[index].push(
                            new NotificationModel(
                                noti['id'],
                                noti['custom_content'],
                                noti['status'],
                                noti['created_at'],
                                noti['associated_id'],
                                noti['associated_type']
                            )
                        );
                    });
                },
                (error) => {
                    console.log(error);
                    this.snackbar.text = error;
                    this.snackbar.status_class = 'error';
                    this.snackbar.activate();
                }
            );
        }
    }
}
